import React from 'react'
import PropTypes from 'prop-types'

export class AspectRatioContainer extends React.PureComponent {
  static propTypes = {
    widthClassName: PropTypes.string,
    aspectClassName: PropTypes.string,
    children: PropTypes.element
  }

  render() {
    const {
      widthClassName = 'w-32',
      aspectClassName = 'aspect-ratio-square',
      children
    } = this.props
    return (
      <div className={`${widthClassName}`}>
        <div className={`${aspectClassName} relative`}>
          <div className="absolute w-full h-full">{children}</div>
        </div>
      </div>
    )
  }
}
